import * as Vue from "vue";
import firebase from "firebase";
import { ActionContext, Store } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import {User} from "../models/user";
import {UserStatus} from "../models/userStatus";
import {ConfigService} from "../helpers/services/configService";
import {RootState} from "../store";
import {AuthMode} from "../models/authMode";

  type SessionContext = ActionContext<SessionState, RootState>;

  export interface SessionState {
    user: User;
    status: UserStatus;
    token: string;
    signUpDetails: {};
    authMode: AuthMode;
  }

  export const sessionModule = {
    namespaced: true,
  
    state: {
      authMode: AuthMode.login,
      signUpDetails: null,
      user: null,
      status: UserStatus.NotLoggedIn,
      token: null
    },

    getters: {
      getCurrentUserId(state: SessionState): string {
        console.log("pulito l'utente");
          return state.user ? state.user.id : null;
        }
    },

    mutations: {
      cleanCurrentUser(state: SessionState) {
        state.user = null;
        state.status = UserStatus.NotLoggedIn;
        state.token = null;
        state.signUpDetails = null;
      },
      setAuthMode(state: SessionState, data: { mode: AuthMode }) {
        state.authMode = data.mode;
      },
      setSignUpDetails(state: SessionState, data) {
        state.signUpDetails = data;
      },
      setCurrentUser(state: SessionState, auth: {user: User, token: string}) {
        state.user = auth.user;
        state.token = auth.token;
        state.status = UserStatus.LoggedIn;
        state.signUpDetails = null;
      },
      startLogging(state: SessionState) {
        state.status = UserStatus.Logging;
      }
    },

    actions: {
      cleanCurrentUser(context: SessionContext): void {
        session.commitCleanCurrentUser(context);
      },
      manualSignUp(context: SessionContext, data: {email: string, password: string, name: string}): Promise<any> {
        session.commitStartLogging(context);
        session.commitSetAuthMode(context, { mode: AuthMode.signUp });
        return new Promise((resolve, reject) => {
          return firebase.auth().createUserWithEmailAndPassword(data.email, data.password)
            .then(response => {
              session.commitSetSignUpDetails(context, data);
              resolve(response);
              // session.commitCreateUser(context);
            })
            .catch(error => {
              session.commitCleanCurrentUser(context);
              reject(error);
              throw error;
            });
        });
      },
      autoSignUp(context: SessionContext): Promise<any> {
        session.commitStartLogging(context);
        let token: string;
        return new Promise((resolve, reject) => {
          return firebase.auth().currentUser.getIdToken(true)
            .then(idToken => {
              if (!idToken) throw Error();
              token = idToken;
              return session.dispatchSendUserDetails(context, { user: context.state.signUpDetails, token: idToken });
            })
            .then(user => {
              session.commitSetCurrentUser(context, {user: user, token: token});
              resolve(user);
            })
            .catch(error => {
              session.dispatchSignOut(context)
                .then(error => {
                    session.commitCleanCurrentUser(context);
                    reject(error);
                  }
                );
            });
        });
      },
      sendUserDetails(context: SessionContext, data: {user: any, token: string }): Promise<any> {
        return new Promise((resolve, reject) => {

          let postData = { data:  data.user };
          Vue.http.post(
            ConfigService.profile,
            postData,
            { headers: { Authorization: "bearer " + data.token } }
          )
            .then(response => resolve(response.body))
            .catch(error => reject(error));
        });
      },
      manualLogin(context: SessionContext, data: {email: string, password: string}) {
        session.commitStartLogging(context);
        session.commitSetAuthMode(context, { mode: AuthMode.login });
        let token: string;
        return new Promise((resolve, reject) => {
          return Vue.http.post(ConfigService.access, { grant_type: "password", username: data.email, password: data.password})
            .then(response => {
              if (!response.data.access_token) throw Error();
              token = response.data.access_token;
              localStorage.setItem("token", token);
              return session.dispatchAskUserDetails(context, response.data.access_token);
            })
            .then(user => {
              session.commitSetCurrentUser(context, {user: user, token: token});
              resolve(user);
            })
            .catch(error => {
              session.commitCleanCurrentUser(context);
              reject(error);
            });
        });
      },
      autoLogin(context: SessionContext, data) {
        console.log("token: ", localStorage.getItem("token"));
        let token = localStorage.getItem("token");
        return new Promise((resolve, reject) => {
          return session.dispatchAskUserDetails(context, token).then(user => {
            session.commitSetCurrentUser(context, {user: user, token: token});
            resolve(user);
          })
            .catch(error => {
              session.commitCleanCurrentUser(context);
              reject(error);
            });
        });
      },
      getUserDetails(context: SessionContext, token: string): Promise<any> {
        return new Promise((resolve, reject) => {
            Vue.http.get(ConfigService.profile, {
                headers: {
                  Authorization: "bearer " + token
                }
            })
              .then(response => resolve(response.body.data))
              .catch(error => reject(error));
          });
      },
      signOut(context: SessionContext): Promise<any> {
        session.commitStartLogging(context);
        localStorage.setItem("token", null);
        return new Promise((resolve, reject) => {
            resolve(session.commitCleanCurrentUser(context));
        });
      }
    }

  };

const { commit, read, dispatch } = getStoreAccessors<SessionState, RootState>("session");

const getters = sessionModule.getters;
const actions = sessionModule.actions;
const mutations = sessionModule.mutations;

export const session = {
  readUserId: read(getters.getCurrentUserId),

  dispatchUpdateTotalAmount: dispatch(actions.cleanCurrentUser),
  dispatchManualSignUp: dispatch(actions.manualSignUp),
  dispatchAutoSignUp: dispatch(actions.autoSignUp),
  dispatchSendUserDetails: dispatch(actions.sendUserDetails),
  dispatchManualLogin: dispatch(actions.manualLogin),
  dispatchAutoLogin: dispatch(actions.autoLogin),
  dispatchAskUserDetails: dispatch(actions.getUserDetails),
  dispatchSignOut: dispatch(actions.signOut),

  commitCleanCurrentUser: commit(mutations.cleanCurrentUser),
  commitSetCurrentUser: commit(mutations.setCurrentUser),
  commitStartLogging: commit(mutations.startLogging),
  commitSetAuthMode: commit(mutations.setAuthMode),
  commitSetSignUpDetails: commit(mutations.setSignUpDetails)
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/session.ts